export const URL = "/praas/v1/buildings";
const NOI_BASE_URL = "/praas/v1/noi";
const POWER_REVENUE_URL = "/praas/v1/power-revenue";
const DASHBOARD_URL = "/praas/v1/dashboard";
const CURRENCIES_URL = "/currencies/";
const OB_SPECIFIC_BUILDING_URL = "/onboarding/tasks/onboarding-status/buildings/{id}";
const OPERATOR_OB_URL = `${OB_SPECIFIC_BUILDING_URL}/operator-onboarding`;

const endPoints = {
  AUTH_LOGIN: "/auth/login/",
  AUTH_SSO_EXCHANGE: "/auth/sso/exchange/",
  AUTH_LOGOUT_CALLBACK: "/auth/sso/logout-callback/",
  GET_PROFILE_DATA: "/auth/user-profile/",
  CHANGE_PASSWORD: "/auth/set-pass/",
  VALIDATE_PASSWORD: "/auth/validate-pass/",
  COMPANY_SETTINGS: "/auth/workspace-setting/",

  // currency app
  CURRENCIES: CURRENCIES_URL,

  // dashboard api
  METER_START_DATE: `${DASHBOARD_URL}/user-meter-data-first-date/`,

  // properties tab api
  PUBLIC_CONSUMPTION: `${URL}/public-consumption/`,
  PUBLIC_COSTS: `${URL}/public-costs/`,

  // Tenants tab api
  TENANTS_LIST: `${URL}/tenants-list/`,
  TENANTS: `/praas/v2/buildings/properties/tenants/`,
  UNITS_LIST: `${URL}/units-list/`,
  TENANTS_PROFITABILITY: `${URL}/tenants-profitability/`,

  SETTING_PORTFOLIO_PROFILE: "/onboarding/settings/portfolio-profile/",
  OB_TASKS_GET_BUILDINGS: "/onboarding/tasks/onboarding-status/buildings/",
  OB_TASKS_STATUS: "/onboarding/tasks/onboarding-status/status-data/",
  OB_BUILDING_MANAGER: `${OB_SPECIFIC_BUILDING_URL}/manager-onboarding/`,

  OB_OPERATOR_BUILDING_INFO: `${OPERATOR_OB_URL}/building-info/`,
  OB_OPERATOR_PMC_INFO: `${OPERATOR_OB_URL}/pmc-info/`,
  OB_OPERATOR_ELECTRICITY_DATA: `${OPERATOR_OB_URL}/electricity-data/`,
  OB_OPERATOR_DOWNLOAD_XLSX: `${OB_SPECIFIC_BUILDING_URL}/download-unit-xlsx/`,
  OB_OPERATOR_UNITS_XLSX: `${OPERATOR_OB_URL}/unit-xlsx/`,
  OB_OPERATOR_TENANCY_DATA: `${OPERATOR_OB_URL}/tenancy-data/`,
  RESEND_BOP_INVITE: `${OB_SPECIFIC_BUILDING_URL}/send-bop-invitation/`,
  OB_UPDATE_STATUS: `${OB_SPECIFIC_BUILDING_URL}/onboarding-status/`,
};

export const noiEndPoints = {
  //Overview tab api
  NPV_TOTAL: `${NOI_BASE_URL}/overview/npv/`,
  NOI_INCREASE: `${NOI_BASE_URL}/overview/noi-increase/`,
  ROI_INCREASE: `${NOI_BASE_URL}/overview/roi-increase/`,
  BUILD_INCREASE: `${NOI_BASE_URL}/overview/building-increase/`,
  ASSUMPTIONS: `${NOI_BASE_URL}/overview/assumptions/`,
  GET_PARAMETERS: `${NOI_BASE_URL}/overview/get-parameters/`,
  ADD_PARAMETERS: `${NOI_BASE_URL}/overview/add-parameters/`,

  //Sensitivity tab api
  SENSITIVITY_INITIALS: `${NOI_BASE_URL}/sensitivity-analysis/initial-values/`,
  SENSITIVITY_CALCULATIONS: `${NOI_BASE_URL}/sensitivity-analysis/calculation/`,
};

export const powerRevenueEndPoints = {
  //Sensitivity tab api
  SENSITIVITY_ANALYSIS: `${POWER_REVENUE_URL}/sensitivity-analysis/`,
};

export default endPoints;
